import Utils from "@teamprevent/common/utils";
import * as React from "react";
import {  Grid } from "semantic-ui-react";

import { PartialOhCaseDetailModel } from "../../model";

interface Props {
    ohCase: PartialOhCaseDetailModel;
}

export const OhCaseEmployeeDetails = (props: Props) => (
    <>
        <Grid.Row columns="4">
            <Grid.Column>
                Customer Name
                <h3>{props.ohCase.customerName}</h3>
            </Grid.Column>
            <Grid.Column>
                Job Title
                <h3>{props.ohCase.jobTitle}</h3>
            </Grid.Column>
            <Grid.Column>
                Gender
                <h3>{props.ohCase.sex}</h3>
            </Grid.Column>
            <Grid.Column />
        </Grid.Row>
        <Grid.Row columns="4">
            <Grid.Column>
                Date of Birth
                <h3>{props.ohCase.dateOfBirth && props.ohCase.dateOfBirth.format("L")}</h3>
            </Grid.Column>
            <Grid.Column>
                Age
                <h3>{props.ohCase.dateOfBirth && Utils.calculateAge(props.ohCase.dateOfBirth.format("L")) + "yrs"}</h3>
            </Grid.Column>
            <Grid.Column>
                Employee Unique ID
                <h3>{props.ohCase.employeeSecondaryReference}</h3>
            </Grid.Column>
            <Grid.Column>
                Mobile Number
                <h3>{props.ohCase.mobileNumber}</h3>
            </Grid.Column>
        </Grid.Row>
    </>);
